import biju_dp from "../assets/team/biju_khatri_dhungel.jpeg";
import bulent_dp from "../assets/team/bulent_uyaniker.jpeg";
import charl_dp from "../assets/team/charl_coetzee.jpeg";
import dillon_dp from "../assets/team/dillon_chrimes.jpeg";
import goksenin_dp from "../assets/team/goksenin_sen.jpeg";
import jim_dp from "../assets/team/jim_de_vries.jpeg";
import manish_dp from "../assets/team/manish_kumar_mahato.jpeg";
import mike_dp from "../assets/team/mike_figurski.jpeg";
import monica_dp from "../assets/team/monica_watson.jpeg";
import siddhartha_dp from "../assets/team/siddhartha_shrestha.jpeg";

export const teamMembers = [
  {
    name: "Bülent Uyaniker",
    role: "Managing Director",
    description: "PhD, Physics",
    image: bulent_dp,
    linkedin: "https://www.linkedin.com/in/b%C3%BClentuyaniker/",
  },
  {
    name: "Jim de Vries",
    role: "VP of Business Development",
    description: "B.Sc. E.Eng.",
    image: jim_dp,
    linkedin: "https://www.linkedin.com/in/iqbsdevries/",
  },
  {
    name: "Charl Coetzee",
    role: "Head of Technology",
    description: "M.Sc. E.Eng.",
    image: charl_dp,
    linkedin: "https://www.linkedin.com/in/charl-coetzee-364234/",
  },
  {
    name: "Monica Watson",
    role: "Clinical Sales",
    description: "BCIT",
    image: monica_dp,
    linkedin: "https://www.linkedin.com/in/monica-watson-73718bb7/",
  },
  {
    name: "Goksenin Sen",
    role: "Digital Transformation Manager",
    description: "PhD, Physics Eng.",
    image: goksenin_dp,
    linkedin: "https://www.linkedin.com/in/goksenin-sen-phd-869b8118/",
  },
  {
    name: "Mike Figurski",
    role: "Clinical Advisor",
    description: "MD, CFPC",
    image: mike_dp,
    linkedin: "https://www.linkedin.com/in/mikefigurski/",
  },
  {
    name: "Dillon Chrimes",
    role: "Health Informatics Advisor",
    description: "PhD, Health Informatics",
    image: dillon_dp,
    linkedin: "https://www.linkedin.com/in/dillon-chrimes-39859b8/",
  },
  {
    name: "Siddhartha Shrestha",
    role: "ML Engineer",
    description: "BE Comp. Eng.",
    image: siddhartha_dp,
    linkedin: "https://www.linkedin.com/in/siddharthashrestha/",
  },
  {
    name: "Manish Kumar Mahato",
    role: "Full Stack Engineer",
    description: "B.Sc. E.Eng.",
    image: manish_dp,
    linkedin: "https://www.linkedin.com/in/manishkusw/",
  },
  {
    name: "Biju Khatri Dhungel",
    role: "Full Stack Engineer",
    description: "BIM",
    image: biju_dp,
    linkedin: "https://www.linkedin.com/in/biju-dhungel/",
  },
];
